import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '../config'
import { slugGenerator } from '../../../utils/slugGenerator'
import moment from 'moment'

const RecentPost = ({recentNews}) => {
    return (
        <div>
            <div className="recent-posts mb-50">
                <div className="widget-title">
                    <h3 className="title">Recent Posts</h3>
                </div>
                {recentNews?.map((obj, i) => {
                    return (
                        <div className="recent-post-widget ">
                            <div className="post-img">
                                <Link to={`${config.appUrl}news/${obj.slug}`}  >
                                    <img src={obj?.imageUrl} alt="" className='w-100 object-fit-cover' /></Link>
                            </div>
                            <div className="post-desc">
                                <Link to={`${config.appUrl}news/${obj.slug}`} >{obj?.title}</Link>
                                <span className="date-post">
                                    <i className="bi bi-calendar-event"></i>{moment(obj?.created_at).format("MMMM D, YYYY")}</span>
                            </div>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}

export default RecentPost
